var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"#youtube .cls-1{fill:#420000;opacity:0.12;isolation:isolate;}#youtube .cls-2{fill:currentColor;}")),React.createElement("path",{"className":"cls-1","d":"M17.4,8.4l12.2,8.2,1.6-.8C31.2,15.6,17.4,8.4,17.4,8.4Z","key":1}),React.createElement("path",{"className":"cls-2","d":"M43.2,2.4a7.23,7.23,0,0,0-4.6-2C32.2,0,22.8,0,22.8,0S13.2,0,6.8.4a5.76,5.76,0,0,0-4.6,2C.8,3.8.4,7,.4,7S0,10.8,0,14.4v3.4c0,3.6.4,7.4.4,7.4s.4,3.2,1.8,4.6c1.8,1.8,4,1.8,5,2,3.6.4,15.4.4,15.4.4s9.6,0,16-.4a5.76,5.76,0,0,0,4.6-2c1.4-1.4,1.8-4.6,1.8-4.6s.4-3.6.4-7.4V14.4C45.4,10.8,45,7,45,7S44.6,3.8,43.2,2.4ZM18,22V9.4l12.4,6.4C30.2,15.8,18,22,18,22Z","key":2})]);
}

Youtube.defaultProps = {"id":"youtube","data-name":"Layer 1","viewBox":"0 0 45.4 32.2"};

module.exports = Youtube;

Youtube.default = Youtube;
